import classNames from "classnames";
import { CaseUpdater } from "./Components/CaseUpdater";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { selectIsLocked, selectLocalCaseState } from "../../redux/selectors";
import { useAppModals } from "../../../../app/state/modalSlice/hook/use-app-modals";
import { useModalSelectors } from "../../../../app/state/modalSlice/hook/use-modal-selectors";
import { CaseAiHelper } from "./Components/CaseAiHelper";
import { useCaseUpdater } from "../../hook/use-case-updater";
import { CaseSolutionModal } from "./Components/CaseSolutionModal";
import styles from "./styles.module.css";

export const CaseCreator = () => {
  const caseLocalState = useAppSelector(selectLocalCaseState);
  const isLocked = useAppSelector(selectIsLocked);
  const { handleCloseModal, handleOpenModal } = useAppModals();
  const { handleChangeField, handleClickTip, handleGetCaseSolution } =
    useCaseUpdater();
  const generateSolution = () => {
    handleOpenModal("case_solution_modal", null);
    handleGetCaseSolution();
  };

  return (
    <div className={styles["case-grid-container"]}>
      <CaseUpdater
        caseState={caseLocalState}
        handleClickTip={handleClickTip}
        handleChangeField={handleChangeField}
        isLocked={isLocked ?? false}
      />
      <CaseAiHelper
        handleClickSolutionButton={generateSolution}
        className={classNames(isLocked && styles["helper-locked"])}
      />
      <CaseSolutionModal closeModal={handleCloseModal} />
    </div>
  );
};
